<template>
  <div>
    <el-dialog
      :visible="addUseVisible"
      title="新增模拟盘用户"
      width="400px"
      @close="closeDialog"
      :before-close="closeDialog"
    >
      <el-form
        ref="elForm"
        :model="form"
        size="medium"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item label="合伙人UID">
          <el-input :value="channelUserId" disabled />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请输入邮箱地址"
          />
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-input v-model="form.pwd" type="password" placeholder="请输入密码" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave('elForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'AddUserDialog',
  props: {
    channelId: {
      type: [Number, String],
      default: '',
    },
    channelUserId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      form: {
        email: '',
        pwd: '',
      },
      rules: {
        email: [
          {
            required: true,
            message: '请输入邮箱地址',
            trigger: 'blur',
          },
        ],
        pwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('partnerList', ['addUseVisible']),
  },
  methods: {
    ...mapMutations('partnerList', ['setAddUser']),
    ...mapActions('partnerList', ['addUser']),
    closeDialog() {
      this.form = { email: '', pwd: '' }
      if (this.$refs.elForm) {
        this.$refs.elForm.resetFields()
      }
      this.setAddUser(false)
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }
        if (!this.channelId) {
          this.$message.error('未选择合伙人')
          return
        }
        const email = this.form.email.trim().toLowerCase()
        if (!email.includes('@')) {
          this.$message.error('邮箱格式错误')
          return
        }
        this.addUser({
          id: Number(this.channelId),
          account: email,
          pwd: this.form.pwd,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('添加成功')
            this.closeDialog()
            this.$emit('success')
          } else {
            this.$message.error(res.msg || '添加失败')
          }
        })
      })
    },
  },
}
</script>
